import type { WarningSign } from '../types';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';
import styles from '../App.module.css';

interface WarningSignsProps {
  items: WarningSign[];
}

export function WarningSigns({ items }: WarningSignsProps) {
  const { locale } = useLanguage();
  const ui = getUi(locale);
  const urgent = items.filter((w) => w.level === 'urgent');
  const watch = items.filter((w) => w.level === 'watch');

  return (
    <div className={styles.warningSection}>
      <p className={styles.warningIntro}>{ui.warningSigns.intro}</p>
      <div className={styles.warningGrid}>
        <div className={`${styles.warningCard} ${styles.warningUrgent}`}>
          <h4 className={styles.warningTitle}>{ui.warningSigns.urgentTitle}</h4>
          <ul className={styles.warningList}>
            {urgent.map((w) => (
              <li key={w.id} className={styles.warningItem}>{w.label}</li>
            ))}
          </ul>
        </div>
        <div className={`${styles.warningCard} ${styles.warningWatch}`}>
          <h4 className={styles.warningTitle}>{ui.warningSigns.watchTitle}</h4>
          <ul className={styles.warningList}>
            {watch.map((w) => (
              <li key={w.id} className={styles.warningItem}>{w.label}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
